// extracted by mini-css-extract-plugin
export default {"BlockTemplateFormRoot":"BlockTemplateFormRoot---G3Y1u","BlockTemplateFormContent":"BlockTemplateFormContent---LShfL"};